import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { fetchUsersApi } from '../../../api/admin/user.api';

export const useUserHook = ({
  pageNumber = 1,
  pageSize = 10,
  isRefetch,
  filters = {},
  sortField = '',
  isSortDescending = true,
}: {
  pageNumber?: number;
  pageSize?: number;
  isRefetch?: boolean;
  filters?: any;
  sortField?: string;
  isSortDescending?: boolean;
}) => {
  const [users, setUsers] = useState<any>();
  const [loading, setLoading] = useState<boolean>(false);
  const [total, setTotal] = useState<number>(0);

  useEffect(() => {
    getUsers(pageNumber, pageSize);
  }, [pageNumber, pageSize, isRefetch, filters, sortField, isSortDescending]);

  const getUsers = async (page: number, size: number) => {
    try {
      setLoading(true);
      const { data } = await fetchUsersApi(
        page,
        size,
        filters,
        sortField,
        isSortDescending
      );
      setUsers(data?.data);
      setTotal(data?.total || 0);
    } catch {
      toast.error('Failed to fetch users');
    } finally {
      setLoading(false);
    }
  };

  return {
    data: users,
    loading,
    total,
  };
};
